import { bindActionCreators } from 'redux';
import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { IState } from '../../../redux/reducer';
import { changePwd } from '../ConsoleUsersAction';
import { ChangePasswordComponentV2 } from './ChangePasswordComponentV2';

function mapStateToProps(rootState: IState) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {
    changePwd: bindActionCreators(changePwd, dispatch),
  };
}

export const ChangePasswordContainer = O2OCommonContainer(
  ChangePasswordComponentV2,
  mapStateToProps,
  mapDispatchToProps
);
